export function useGetTenantsFaq() {
  const eviFaqLink =
    'https://hvm-prod-resources-frontend.s3.eu-central-1.amazonaws.com/11202/files/file/file_505617100543040516420250715FAQ%20HVM.pdf';
  const energieScwabenFaqLink =
    'https://hvm-prod-resources-frontend.s3.eu-central-1.amazonaws.com/11002/files/file/file_5219702490410476523FAQ-Faltblatt_MeinZuhause.pdf';

  return { eviFaqLink, energieScwabenFaqLink };
}
